import { type AdvancedFilterState } from '../types';

import { ADVANCED_FILTERS_METHODS } from './global';

// ENTITLEMENT TAB DETAILS PAGE
// Tabs
export const VIOLATIONS_DETAILS_TABS: Record<string, string> = {
  TAB_CONFLICTS: 'violations_tab_details_page_conflicts_tab',
  TAB_SUMMARY: 'violations_tab_details_page_summary_tab',
  TAB_MITIGATING: 'violations_tab_details_page_mitigating_tab',
  TAB_USER: 'violations_tab_details_page_user_tab',
  TAB_HISTORY: 'violations_tab_details_page_history_tab',
} as const;

export const VIOLATION_TAB_OPTIONS = [
  {
    label: 'Conflicts',
    value: VIOLATIONS_DETAILS_TABS.TAB_CONFLICTS,
    icon: 'JobFunction',
  },
  {
    label: 'Mitigating Control',
    value: VIOLATIONS_DETAILS_TABS.TAB_MITIGATING,
    icon: 'SodMitigate',
  },
  {
    label: 'Summary',
    value: VIOLATIONS_DETAILS_TABS.TAB_SUMMARY,
    icon: 'Document',
  },
  {
    label: 'User',
    value: VIOLATIONS_DETAILS_TABS.TAB_USER,
    icon: 'User',
  },
  {
    label: 'History',
    value: VIOLATIONS_DETAILS_TABS.TAB_HISTORY,
    icon: 'Time',
  },
];

// Conlict tabs
const VIOLATIONS_TAB_DETAILS_AD_FILTER_CAT: Record<string, string> = {
  ENTITLEMENT: 'Entitlement',
} as const;

export const VIOLATIONS_TAB_DETAILS_AD_FILTER: Record<
  string,
  AdvancedFilterState
> = {
  ASSIGNEDENTITLEMENTS: {
    label: 'Assigned Entitlement',
    value: 'assignedEntitlements',
    category: VIOLATIONS_TAB_DETAILS_AD_FILTER_CAT.ENTITLEMENT,
    method: ADVANCED_FILTERS_METHODS.SEARCH,
  },
  VIOLATINGENTITLEMENTS: {
    label: 'Violating Entitlement',
    value: 'violatingEntitlements',
    category: VIOLATIONS_TAB_DETAILS_AD_FILTER_CAT.ENTITLEMENT,
    method: ADVANCED_FILTERS_METHODS.SEARCH,
  },
  VIOLATINGSOXCRITICALITY: {
    label: 'Violating SOX Critical Entitlement',
    value: 'violatingSoxCriticality',
    category: VIOLATIONS_TAB_DETAILS_AD_FILTER_CAT.ENTITLEMENT,
    method: ADVANCED_FILTERS_METHODS.FIXED,
    options: [
      {
        label: 'Very Low',
        value: 'VERY_LOW',
        isChecked: false,
      },
      {
        label: 'Low',
        value: 'LOW',
        isChecked: false,
      },
      {
        label: 'Medium',
        value: 'MEDIUM',
        isChecked: false,
      },
      {
        label: 'High',
        value: 'HIGH',
        isChecked: false,
      },
      {
        label: 'Very High',
        value: 'VERY_HIGH',
        isChecked: false,
      },
    ],
  },
  VIOLATINGSYSCRITICALITY: {
    label: 'Violating Sys Critical Entitlement',
    value: 'violatingSysCriticality',
    category: VIOLATIONS_TAB_DETAILS_AD_FILTER_CAT.ENTITLEMENT,
    method: ADVANCED_FILTERS_METHODS.FIXED,
    options: [
      {
        label: 'Very Low',
        value: 'VERY_LOW',
        isChecked: false,
      },
      {
        label: 'Low',
        value: 'LOW',
        isChecked: false,
      },
      {
        label: 'Medium',
        value: 'MEDIUM',
        isChecked: false,
      },
      {
        label: 'High',
        value: 'HIGH',
        isChecked: false,
      },
      {
        label: 'Very High',
        value: 'VERY_HIGH',
        isChecked: false,
      },
    ],
  },
  VIOLATINGPRIVILEDGED: {
    label: 'Violating Privileged Entitlement',
    value: 'violatingPrivileged',
    category: VIOLATIONS_TAB_DETAILS_AD_FILTER_CAT.ENTITLEMENT,
    method: ADVANCED_FILTERS_METHODS.FIXED,
    options: [
      {
        label: 'Very Low',
        value: 'VERY_LOW',
        isChecked: false,
      },
      {
        label: 'Low',
        value: 'LOW',
        isChecked: false,
      },
      {
        label: 'Medium',
        value: 'MEDIUM',
        isChecked: false,
      },
      {
        label: 'High',
        value: 'HIGH',
        isChecked: false,
      },
      {
        label: 'Very High',
        value: 'VERY_HIGH',
        isChecked: false,
      },
    ],
  },
} as const;

export const VIOLATIONS_TAB_DETAILS_INITIAL_FILTERS: AdvancedFilterState[] =
  Object.values(VIOLATIONS_TAB_DETAILS_AD_FILTER).map((filter) => ({
    ...filter,
    isDisabled: false,
    isChecked: true,
  }));

// Expander
export interface ExpanderState {
  label: string;
  value: string;
  isChecked: boolean;
  isDisabled: boolean;
}

export const VIOLATIONS_TAB_DETAILS_EXPANDER: ExpanderState[] = [
  {
    label: 'Expand Next Level',
    value: '1',
    isChecked: false,
    isDisabled: false,
  },
  {
    label: 'Collapse All',
    value: '-1',
    isChecked: false,
    isDisabled: false,
  },
];

// ENTITLEMENT TAB DETAILS PAGE
export const ENTITLEMENT_DETAILS_TABS: Record<string, string> = {
  TAB_SUMMARY: 'entitlement_tab_details_page_summary_tab',
  TAB_RISKS: 'entitlement_tab_details_page_inherent_risks_tab',
  TAB_USERS: 'entitlement_tab_details_page_users_tab',
  TAB_VIOLATIONS: 'entitlement_tab_details_page_violations_tab',
  TAB_RISKS_CONFLICTS:
    'entitlement_tab_details_page_inherent_risks_tab_conflicts_tab',
  TAB_RISKS_SUMMARY:
    'entitlement_tab_details_page_inherent_risks_tab_summary_tab',
};

export const ENTITLEMENT_TAB_OPTIONS = [
  {
    label: 'Summary',
    value: ENTITLEMENT_DETAILS_TABS.TAB_SUMMARY,
    icon: 'Document',
  },
  {
    label: 'Inherent Risks',
    value: ENTITLEMENT_DETAILS_TABS.TAB_RISKS,
    icon: 'CriticalHighRiskHexagon',
  },
  {
    label: 'Users',
    value: ENTITLEMENT_DETAILS_TABS.TAB_USERS,
    icon: 'User',
  },
  {
    label: 'Violations',
    value: ENTITLEMENT_DETAILS_TABS.TAB_VIOLATIONS,
    icon: 'SOD',
  },
];

export const RISK_DETAILS_TAB_OPTIONS = [
  {
    label: 'Conflicts',
    value: ENTITLEMENT_DETAILS_TABS.TAB_RISKS_CONFLICTS,
    icon: 'JobFunction',
  },
  {
    label: 'Summary',
    value: ENTITLEMENT_DETAILS_TABS.TAB_RISKS_SUMMARY,
    icon: 'Document',
  },
];
